 
import React from 'react';

const Analytics = () => {
  return (
    <div className="analytics-page">
      <h1>Analytics</h1>
      <p>Analytics charts will be here...</p>
    </div>
  );
};

export default Analytics;